<template lang="pug">
.efight-mainmarket-group
  //- small {{ source.marketId }}
  .efight-mainmarket-item.collapsed(
    v-if="source != null"
    type='button' 
    :id="source.id"
    data-toggle='collapse' 
    :data-target="'#mainmarket-' + source.matchId"
  )
    .row.mainmarket-item-top
      efTimer(:source="source" :horiz="false" :class="{ 'd-none' : source.marketId == 3 }")
      //- .mr-2.time-remaining.red-text
      //-   i.far.fa-stopwatch
      //-   span 58s
      .live-icon-wrapper(:class="{ 'd-none' : source.marketId != 3 }")
        img.live-icon(src='images/egame/live-icon.svg')
        span.mx-1 LIVE
        .live-dot
    .mainmarket-item-match
      .team1
        img.characters(:src="getImage(source.sportsId, source.matchBody[22])")
        span.name {{ source.homeTeam }}
      .vs
        img.img-fluid(src='images/egame/vs.svg')
      .team2
        img.characters(:src="getImage(source.sportsId, source.matchBody[23])")
        span.name {{ source.awayTeam }}
  .collapse.show(
    :id="'mainmarket-' + source.matchId"
  )
    .match-collapse-body
      .efight-marketgroup-content
        .row.justify-content-center.align-items-center.bettype-row
          .col-6.bettype-col {{ $tc("m.BT_HDP", 1) }}
        .row.justify-content-center.m-0
          .col-6.efight-odds-group
            .efight-odds.justify-content-center
              .bettype H
              template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
                OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="1")
              template(v-else)
                OddsDisabled
          .col-6.efight-odds-group
            .efight-odds.justify-content-center
              .bettype A
              template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
                OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="2")
              template(v-else)
                OddsDisabled
        template(v-if="[43, 44].includes(source.sportsId)")
          .row.justify-content-center.align-items-center.bettype-row
            .col-6.bettype-col {{ $tc("m.BT_OU", 1) }}
              span(v-if="details['ou'] != null && details['ou'][0] != null") ({{ details['ou'][0][8] }})
          .row.justify-content-center.m-0
            .col-6.efight-odds-group
              .efight-odds.justify-content-center
                .bettype O
                template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
                  OddsItem(:odds="details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="details" homeAway="1")
                template(v-else)
                  OddsDisabled
            .col-6.efight-odds-group
              .efight-odds.justify-content-center
                .bettype U
                template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
                  OddsItem(:odds="details['ou'][0]" idx=11 :typ="oddsType" dataType="1" :mode="'ou'" label="under" count=0 :details="details" homeAway="2")
                template(v-else)
                  OddsDisabled
        template(v-if="[42].includes(source.sportsId)")
          .row.justify-content-center.align-items-center.bettype-row
            .col-6.bettype-col {{ $tc("m.BT_OE", 1) }}
          .row.justify-content-center.m-0
            .col-6.efight-odds-group
              .efight-odds.justify-content-center
                .bettype O
                template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][5] != 0 && details['oe'][0][5] != ''")
                  OddsItem(:odds="details['oe'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .col-6.efight-odds-group
              .efight-odds.justify-content-center
                .bettype E
                template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][7] != 0 && details['oe'][0][7] != ''")
                  OddsItem(:odds="details['oe'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled


        //- .row.justify-content-center.align-items-center.bettype-row
        //-   .col-6.bettype-col {{ $tc("m.BT_HDP", 1) }}
        //-   .col-6.bettype-col(v-if="[43, 44].includes(source.sportsId)") {{ $tc("m.BT_OU", 1) }}
        //-     span(v-if="details['ou'] != null && details['ou'][0] != null") ({{ details['ou'][0][8] }})
        //-   .col-6.bettype-col(v-if="[42].includes(source.sportsId)") {{ $tc("m.BT_OE", 1) }}
        //- .row.justify-content-center.m-0
        //-   template(v-if="[41].includes(source.sportsId)")
        //-     .col-6.efight-odds-group
        //-       .efight-odds.justify-content-center
        //-         .bettype H
        //-         template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
        //-           OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="1")
        //-         template(v-else)
        //-           OddsDisabled
        //-     .col-6.efight-odds-group
        //-       .efight-odds.justify-content-center
        //-         .bettype A
        //-         template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
        //-           OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="2")
        //-         template(v-else)
        //-           OddsDisabled
        //-   template(v-else)
        //-     .col-6.efight-odds-group
        //-       .efight-odds.justify-content-center
        //-         .bettype H
        //-         template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
        //-           OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="1")
        //-         template(v-else)
        //-           OddsDisabled
        //-       .efight-odds.justify-content-center
        //-         .bettype A
        //-         template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
        //-           OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="2")
        //-         template(v-else)
        //-           OddsDisabled
        //-     .col-6.efight-odds-group(v-if="[43, 44].includes(source.sportsId)")
        //-       .efight-odds.justify-content-center
        //-         .bettype O
        //-         template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
        //-           OddsItem(:odds="details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="details" homeAway="1")
        //-         template(v-else)
        //-           OddsDisabled
        //-       .efight-odds.justify-content-center
        //-         .bettype U
        //-         template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
        //-           OddsItem(:odds="details['ou'][0]" idx=11 :typ="oddsType" dataType="1" :mode="'ou'" label="under" count=0 :details="details" homeAway="2")
        //-         template(v-else)
        //-           OddsDisabled
        //-     .col-6.efight-odds-group(v-if="[42].includes(source.sportsId)")
        //-       .efight-odds.justify-content-center
        //-         .bettype O
        //-         template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][5] != 0 && details['oe'][0][5] != ''")
        //-           OddsItem(:odds="details['oe'][0]" idx=5 :typ="oddsType" dataType="2")
        //-         template(v-else)
        //-           OddsDisabled
        //-       .efight-odds.justify-content-center
        //-         .bettype E
        //-         template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][7] != 0 && details['oe'][0][7] != ''")
        //-           OddsItem(:odds="details['oe'][0]" idx=7 :typ="oddsType" dataType="2")
        //-         template(v-else)
        //-           OddsDisabled

</template>

<script>
import config from "@/config";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default{
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    newFeatures() {
      return config.newFeatures
    }
  },
  methods: {
    getImage(s, img) {
      return config.resourceImgUrl + "/ef/" + (this.newFeatures ? 'uat/' : 'prod/') + s + "/" + img + ".png";
    }
  }
}
</script>